import { ComponentPropsWithRef, forwardRef } from "react";

interface Props extends ComponentPropsWithRef<"svg"> {}

export const MorningIcon = forwardRef<SVGSVGElement, Props>((props, ref) => {
  return (
    <svg height={20} width={20} {...props} data-component="MorningIcon" ref={ref}>
      <g
        fill="#727272"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        transform="translate(-308.000000, -759.000000) translate(18.000000, 709.000000) translate(0.000000, 8.000000) translate(0.000000, 32.000000) translate(290.000000, 10.000000)"
      >
        <polygon points="10.5 0.901234568 10.5 4.30864198 11.5 4.30864198 11.5 0.901234568"></polygon>
        <polygon
          points="16.3081392 3.28297773 16.3081392 6.69038514 17.3081392 6.69038514 17.3081392 3.28297773"
          transform="translate(16.808139, 4.986681) rotate(50.000000) translate(-16.808139, -4.986681) "
        ></polygon>
        <polygon
          points="4.69186077 3.28297773 4.69186077 6.69038514 5.69186077 6.69038514 5.69186077 3.28297773"
          transform="translate(5.191861, 4.986681) rotate(-50.000000) translate(-5.191861, -4.986681) "
        ></polygon>
        <path d="M15.944 10.444a4.944 4.944 0 1 0-9.888 0h9.888z"></path>
        <polygon
          points="10.0555556 0.5 10.0555556 20.9444444 11.0555556 20.9444444 11.0555556 0.5"
          transform="translate(10.555556, 10.722222) rotate(90.000000) translate(-10.555556, -10.722222) "
        ></polygon>
      </g>
    </svg>
  );
});

export const NoonIcon = forwardRef<SVGSVGElement, Props>((props, ref) => {
  return (
    <svg height={20} width={20} {...props} data-component="NoonIcon" ref={ref}>
      <g
        fill="#727272"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        transform="translate(-309.000000, -838.000000) translate(18.000000, 709.000000) translate(0.000000, 125.000000) translate(291.000000, 4.000000)"
      >
        <polygon points="9.78571429 0.912698413 9.78571429 4.38888889 10.7857143 4.38888889 10.7857143 0.912698413"></polygon>
        <polygon
          points="15.7598003 3.36249138 15.7598003 6.83868186 16.7598003 6.83868186 16.7598003 3.36249138"
          transform="translate(16.259800, 5.100587) rotate(50.000000) translate(-16.259800, -5.100587) "
        ></polygon>
        <polygon
          points="3.81162823 3.36249138 3.81162823 6.83868186 4.81162823 6.83868186 4.81162823 3.36249138"
          transform="translate(4.311628, 5.100587) rotate(-50.000000) translate(-4.311628, -5.100587) "
        ></polygon>
        <polygon points="9.78571429 17.6111111 9.78571429 21.0873016 10.7857143 21.0873016 10.7857143 17.6111111"></polygon>
        <polygon
          points="15.7598003 15.1613181 15.7598003 18.6375086 16.7598003 18.6375086 16.7598003 15.1613181"
          transform="translate(16.259800, 16.899413) rotate(-50.000000) translate(-16.259800, -16.899413) "
        ></polygon>
        <polygon
          points="3.81162823 15.1613181 3.81162823 18.6375086 4.81162823 18.6375086 4.81162823 15.1613181"
          transform="translate(4.311628, 16.899413) rotate(50.000000) translate(-4.311628, -16.899413) "
        ></polygon>
        <path d="M10.286 15.643a5.071 5.071 0 1 1 0-10.143 5.071 5.071 0 0 1 0 10.143z"></path>
        <polygon
          points="18.3857143 8.83333333 18.3857143 12.3095238 19.3857143 12.3095238 19.3857143 8.83333333"
          transform="translate(18.885714, 10.571429) rotate(90.000000) translate(-18.885714, -10.571429) "
        ></polygon>
        <polygon
          points="1.24603175 8.83333333 1.24603175 12.3095238 2.24603175 12.3095238 2.24603175 8.83333333"
          transform="translate(1.746032, 10.571429) rotate(90.000000) translate(-1.746032, -10.571429) "
        ></polygon>
      </g>
    </svg>
  );
});

export const EveningIcon = forwardRef<SVGSVGElement, Props>((props, ref) => {
  return (
    <svg
      height="22px"
      viewBox="0 0 11 18"
      width="21px"
      {...props}
      data-component="EveningIcon"
      ref={ref}
    >
      <path
        d="M9.851 12.959L10.9 12.5l-1.049-.458a5.5 5.5 0 0 1 0-10.086L10.9 1.5l-1.049-.458a6.5 6.5 0 1 0 0 11.918z"
        fill="#727272"
        fillRule="nonzero"
      ></path>
    </svg>
  );
});
